import React from 'react';

const Canceled = () => {
  return (
    <div className="mt-3 flex items-center justify-center">
      <h1 className="text-3xl font-bold text-pink-500">Đã gỡ bài</h1>
    </div>
  );
};

export default Canceled;
